import { vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4d015bc9"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "_wrap" }
const _hoisted_2 = { style: {"width":"100%","position":"relative"} }
const _hoisted_3 = { class: "input_group" }
const _hoisted_4 = { class: "input_group" }
const _hoisted_5 = { class: "input_group" }
const _hoisted_6 = { style: {"width":"100%","position":"relative"} }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "textarea_placeholder" }, "留言", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _withDirectives(_createElementVNode("input", {
          type: "text",
          class: "input_line _text",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.city) = $event)),
          placeholder: "城市*"
        }, null, 512), [
          [_vModelText, _ctx.form.city]
        ]),
        _withDirectives(_createElementVNode("input", {
          type: "text",
          class: "input_line _text",
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.company) = $event)),
          placeholder: "单位*"
        }, null, 512), [
          [_vModelText, _ctx.form.company]
        ])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _withDirectives(_createElementVNode("input", {
          type: "text",
          class: "input_line _text",
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.name) = $event)),
          placeholder: "姓名*"
        }, null, 512), [
          [_vModelText, _ctx.form.name]
        ]),
        _withDirectives(_createElementVNode("input", {
          type: "text",
          class: "input_line _text",
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.email) = $event)),
          placeholder: "邮箱*"
        }, null, 512), [
          [_vModelText, _ctx.form.email]
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _withDirectives(_createElementVNode("input", {
          type: "text",
          class: "input_line _text",
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.phone) = $event)),
          style: _normalizeStyle(!_ctx.showExpansion?'margin-bottom:0px;':''),
          placeholder: "电话*"
        }, null, 4), [
          [_vModelText, _ctx.form.phone]
        ]),
        _withDirectives(_createElementVNode("input", {
          type: "text",
          class: "input_line _text",
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.form.title) = $event)),
          placeholder: "职位"
        }, null, 512), [
          [_vModelText, _ctx.form.title]
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _hoisted_7,
      _withDirectives(_createElementVNode("textarea", {
        name: "message",
        placeholder: "",
        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.form.message) = $event))
      }, null, 512), [
        [_vModelText, _ctx.form.message]
      ]),
      _createElementVNode("div", {
        class: "submit_btn",
        onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.onSubmit && _ctx.onSubmit(...args)))
      }, " 提交 ")
    ])
  ]))
}